import * as Sentry from '@sentry/react';
import { SENTRY_DSN_KEY } from './constants';
import { getReleaseVersion } from './utils';
/**
 * config Sentry for uncaught events
 */
var configureSentry = function (_a) {
    var env = _a.env;
    var release = getReleaseVersion(env);
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/
    Sentry.init({
        release: release,
        dsn: SENTRY_DSN_KEY,
        environment: env || 'local',
        beforeSend: function (event, hint) {
            // we want to filter out event that are fetch portal data failed, ie when user is not authencaiated but try to load
            // return null // if we dont want to send event to sentry
            return event;
        },
    });
};
export default configureSentry;
